export function openSnackBar(openSnackBar:boolean,isSuccess:boolean,message:string) {
    return {
      type: "@@OpenSnackBar/SUCCESS" as const,
      openSnackBar,
      isSuccess,
      message
    }
  }

  export function closeSnackBar(openSnackBar:boolean,isSuccess:boolean,message:string) {
    return {
      type: "@@CloseSnackBar" as const,
      openSnackBar,
      isSuccess,
      message
    }
  }




  export type InitSnackBarAction =
   | ReturnType<typeof openSnackBar>
   |ReturnType<typeof closeSnackBar>